//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VocHeaderMenuMobile from "./header-menu-mobile.vue"
import mixins from "./mixins"
import VocServicer from "@packages/servicer/src/main"
// eslint-disable-next-line no-unused-vars

    import Vue from "vue"

    
    let _i18n_vue = new Vue();
    const $t = _i18n_vue.$t.bind(_i18n_vue);
    

export default {
  name: "VocHeaderMenu",
  components: {
    VocHeaderMenuMobile,
    VocServicer
  },
  mixins: [mixins],
  data() {
    return {
      wrapperClass: "",
      domSize: {
        leftOffsetWidth: undefined,
        rightOffsetWidth: undefined
      }
    }
  },
  methods: {
    menuClick(item) {
      this.$emit("menuClick", item)
    },
    async calcWidthContainer() {
      await this.$nextTick()
      const offsetWidth = this.$el.offsetWidth
      if (offsetWidth <= 1024) {
        this.wrapperClass = "h5"
        return
      }
      if (offsetWidth - 40 > this.domSize.leftOffsetWidth + this.domSize.rightOffsetWidth) {
        this.wrapperClass = "pc"
      } else {
        this.wrapperClass = "h5"
      }
    },
    async calcMenuWidth() {
      await this.$nextTick()
      this.domSize.leftOffsetWidth = this.$refs.headerLeft.offsetWidth
      this.domSize.rightOffsetWidth = this.$refs.headerRight.offsetWidth
      this.calcWidthContainer()
    }
  },
  async mounted() {
    this.resizeListener = this.calcWidthContainer.bind(this)
    window.addEventListener("resize", this.resizeListener)
  },
  beforeDestroy() {
    if (this.resizeListener) {
      window.removeEventListener("resize", this.resizeListener)
    }
  }
}
